var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaptureimageemptystate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 105,
    viewBox: "0 0 88 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H76C82.6274 0 88 5.37258 88 12V93C88 99.6274 82.6274 105 76 105H12C5.37258 105 0 99.6274 0 93V12Z",
    fill: "#EDECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_376_31549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0195 65.4312C53.9607 65.4312 62.0195 54.4151 62.0195 40.826C62.0195 27.2369 53.9607 16.2207 44.0195 16.2207C34.0784 16.2207 26.0195 27.2369 26.0195 40.826C26.0195 54.4151 34.0784 65.4312 44.0195 65.4312Z",
    fill: "#A19CB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0195 90.0364C56.1698 90.0364 66.0195 84.0276 66.0195 76.6154C66.0195 69.2031 56.1698 63.1943 44.0195 63.1943C31.8693 63.1943 22.0195 69.2031 22.0195 76.6154C22.0195 84.0276 31.8693 90.0364 44.0195 90.0364Z",
    fill: "#C6C6C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_376_31549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 85,
    fill: "white",
    transform: "translate(14.0195 2.7998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptureimageemptystate);
export default __webpack_public_path__ + "static/media/capture image empty state.7fe8a62ebec112b07b7a1878b1f6e04f.svg";
export { ForwardRef as ReactComponent };